<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import AddWithFeedback from '@/components/Molecules/AddWithFeedback.vue'
import FormButton from '@/components/Atoms/FormButton.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconCameraFilled from '@/components/icon/IconCameraFilled.vue'

const emit = defineEmits(['add-stream'])

const store = useStore()

const allInOneStreams = computed(() => store.getters['Streams/allInOneStreams'] || [])
const playoutConfig = computed(() => store.getters['Playout/playoutConfig'])
const playlist = computed(() => store.getters['Playout/playlist'] || [])

const isDestination = (stream) => stream._id === playoutConfig.value?.destination
const streamAddCount = (stream) =>
	playlist.value.filter((item) => item.sourceLocation === stream.key).length

const disabledReason = (stream) => {
	if (isDestination(stream)) return 'This stream is set as destination and cannot be added.'
	return ''
}

const isDisabled = (stream) => !!disabledReason(stream)

const addStream = (stream) => {
	if (isDisabled(stream)) return
	emit('add-stream', stream)
}
</script>

<template>
	<section class="bg-surface-2 rounded-lg">
		<div
			v-if="!allInOneStreams.length"
			class="p-8 text-center flex flex-col items-center gap-3"
		>
			<p class="text-sm text-surface-7 m-0">No live sources available</p>
			<FormButton type="main" label="Go to Livestreams" to="/dashboard" />
		</div>
		<ul v-else class="divide-y divide-surface-3 px-4">
			<li
				v-for="stream in allInOneStreams"
				:key="stream._id"
				class="flex items-center gap-3 py-3"
			>
				<icon-base class="shrink-0 text-surface-text-1">
					<icon-camera-filled />
				</icon-base>
				<span class="text-sm text-white truncate flex-1" :title="stream.name">
					{{ stream.name }}
				</span>
				<AddWithFeedback
					:count="streamAddCount(stream)"
					:disabled="isDisabled(stream)"
					:disabled-tooltip="disabledReason(stream)"
					label="Add to schedule"
					success-label="Added to schedule"
					@add="addStream(stream)"
				/>
			</li>
		</ul>
	</section>
</template>

<style scoped></style>
